export const GET_ALL_VISIBLE_CLIENTS = 'GET_ALL_VISIBLE_CLIENTS';
export const GET_CLIENTS_FAIL = 'GET_CLIENTS_FAIL';
export const GET_CO_BROKER_SALES_AGENT = 'GET_CO_BROKER_SALES_AGENT';
export const HANDLE_DOC_SUCCESS = 'HANDLE_DOC_SUCCESS';
